import { Box, BoxProps, ModBox } from '@jfs/ui-new'
import { useNavigation, useRoute } from '@react-navigation/native'
import { useState } from 'react'
import { titleCase } from '../../../comps/CustomHeader/headerFunctionHelpers'
import { HeaderLeft } from '../../../comps/MobileCustomHeader/HeaderLeft'
import { useStores } from '../../../data/store'
import { BillerCategoryMasterId } from '../../../util/billPaymentUtil'
import { SelectStateCity } from '../Education/SelectStateCity'
import { OperatorList } from './OperatorList'

const List = () => {
  const params: any = useRoute().params ?? {}
  const navigation = useNavigation()

  const { category, categoryId } = useStores((root) => ({
    category: root.billPayments?.transaction?.txnMetaData.category,
    categoryId: root.billPayments?.transaction?.txnMetaData.catId,
  }))

  const tittle = params.tittle
  const [headerTitle, setHeaderTitle] = useState(tittle === 'Education Fees' ? 'Select State' : tittle)

  navigation.setOptions({
    gestureEnabled: true,
    headerLeft: () => <HeaderLeft />,
    headerStyle: { borderBottomColor: 'rgba(0,0,0,0)' },
    headerTintColor: '#fff',
    headerBackVisible: true,
    headerTransparent: true,
    title: titleCase(params?.title ?? ''),
    headerTitleStyle: {
      fontSize: 18,
      fontFamily: 'JioType-Bold',
    },
  })

  return (
    <Box flex={1} backgroundColor="SECONDARY" position={'relative'} pt={70}>
      <ModBox {...styles.listWrapper} backgroundColor={'WHITE'}>
        <SelectStateCity
          title={headerTitle}
          setHeaderTitle={setHeaderTitle}
          hide={categoryId !== BillerCategoryMasterId.EducationFee}
        />
        <OperatorList title={params.title} hide={categoryId === BillerCategoryMasterId.EducationFee} />
      </ModBox>
    </Box>
  )
}

const styles = {
  listWrapper: {
    flex: 1,
    backgroundColor: 'WHITE',
    pv: 25,
    borderTopLeftRadius: 24,
    borderTopRightRadius: 24,
    width: '100%',
    zIndex: 4,
    overflow: 'auto',
  } as BoxProps,
}

export default List
